// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1ZpfK","cell":"ColumnAccessor_cell__3QVyz","firstCellAccent":"ColumnAccessor_firstCellAccent__1yAcs"};